module.exports = __webpack_public_path__ + "img/nsh-home.5b7b28b2.jpg";